import React from "react";
import "./Home.css";
import Hero from "../components/Hero";
import About from "../components/About";
import HomeServices from "../components/HomeServices";
import HowWeWork from "../components/HowWeWork";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="page-wrapper">
      {/* main content */}
      <div className="page-content">
        <Hero />
        <About />
        <HomeServices />
        <HowWeWork />
        <Testimonials />
        <CTA />
      </div>

      <Footer />
    </div>
  );
};

export default Home;